<template>
    <b-card-code>
      <span v-if="editando">
        <b-row class="justify-content-center">
          <b-col cols="3">
            <h3 style="text-align: center">{{skuSelect.skuSingle}}</h3>
           </b-col>
        </b-row>
        <b-row class="justify-content-center">

          <b-col cols="3">
            <b-form-group
                label="Seleccionar Sku Master"
                label-for="basicInput"
                >
                <v-select
                  v-model="skuMaster"
                  :options="listaSku"
                />
              </b-form-group>

           </b-col>
        </b-row>

        <b-row class="justify-content-center">
          <b-col cols="3">
              <div style="text-align: center; margin-bottom: 10px">
                <b-button variant="outline-primary" @click="guardarMaster">
                <i class="fa-regular fa-floppy-disk"></i>
                <span class="align-middle"> Guardar</span>
                </b-button>
              </div>
          </b-col>
         </b-row>

      </span>
      
        <b-form-group
            label="Buscar"
            label-for="basicInput">
            <b-form-input
            id="basicInput"
            placeholder="Buscar"
            v-model="buscar"
            />
        </b-form-group>

        <b-table
            :items="articulosBusqueda"
            :fields="columnasSku"
            class="table table-borderless table-prevision"
            no-border-collapse
            sort-icon-left
            striped 
            ref="table"
          >

           <template #cell(options)="data">
              <b-button variant="outline-success" class="btn-icon rounded-circle" @click="selectMaster(data.item)">
                <i class="fa-solid fa-pen-to-square"></i>
              </b-button>        
               <b-button style="margin-left: 5px" variant="outline-danger" class="btn-icon rounded-circle" @click="deleteMaster(data.item)">
                <i class="fa-solid fa-trash"></i>
              </b-button>            
            </template>
        </b-table>
    </b-card-code>
</template>

<script>
import axios from '@axios'
/*import VueApexCharts from 'vue-apexcharts'*/
import { BTable , BFormCheckbox, BFormInput, BFormGroup, BModal, BCardText, BCardBody, BCard, BRow, BCol} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import { $themeColors } from '@themeConfig'
import { useTimeout } from '@vueuse/shared'
import vSelect from 'vue-select'
import { forEach } from 'postcss-rtl/lib/affected-props'


  export default {
    components: {
        BCardCode,
        BTable,
        BFormInput,
        BFormGroup,
        BRow,
        BCol,
        vSelect,
    },
    data () {
      return {       
        columnasSku: [
        {
            key: "options",
            label: "",
            thStyle: { width: "10%" },
        },
        {
          key: "skuSingle",
          label: "SKU",
          sortable: true,
        },
        {
          key: "skuMaster",
          label: "Sku Master",
          sortable: true,
        },
        {
          key: "numMano",
          label: "Tareas Mano",
          sortable: true,
        },
        {
          key: "numCorte",
          label: "Tareas Corte",
          sortable: true,
        }],
        articulos: [],
        articulosBusqueda: [],
        buscar: "",
        skuSelect: "",
        skuMaster: "",
        listaSku: [],
        editando: false
      }
    },
    methods:{
      loadItems(){ 
        axios.post("/uso", {seccion:"skuMaster"});
        axios
            .get("/sku/link")
            .then(response => {
                return response.data;
            })
            .then(resArticulos => {
                this.articulos = resArticulos;
                this.articulosBusqueda = resArticulos;
                
                this.articulos.forEach(item => {
                  this.listaSku.push(item.skuSingle + ` (${item.numMano} - ${item.numCorte})`);
                });
            });
      },
      selectMaster(data){
        this.editando = true;
        this.skuSelect = data;
         document.documentElement.scrollTop = 0;
      },
      guardarMaster(){
        if(this.skuMaster.length > 2)
        {
          let master = this.skuMaster.split(' ')[0];

          axios
            .post("/sku/link", {master: master, sku: this.skuSelect.skuSingle})
            .then(response => {
                return response.data;
            })
            .then(res => {

              this.skuSelect.skuMaster = master;
              this.editando = false;
            });
          }
      },
      deleteMaster(itemDelete){
         this.$swal({
            title: 'Estas seguro que quieres quitar el enlace',
            icon: 'error',            
            confirmButtonText: 'Si, quitar',
            showCancelButton: true,
            cancelButtonText: 'No',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
          }).then(result => {

             axios
              .delete("/sku/link", { data: {sku: itemDelete.skuSingle}} )
              .then(response => {
                  return response.data;
              })
              .then(res => {
                  itemDelete.skuMaster = '';
              });
            
          });

       
      }
    },
     mounted() { 
      this.loadItems();
    },
     watch: {
      buscar(){
        this.articulosBusqueda = this.articulos.filter(item => {
          const skuSingleLower = item.skuSingle.toLowerCase();
          const skuMasterLower = item.skuMaster.toLowerCase();
          const buscarLower = this.buscar.toLowerCase();
          return skuSingleLower.includes(buscarLower) || skuMasterLower.includes(buscarLower);
        });

      },
    }

  }
</script>

<style lang="scss">
  @import '../@core/scss/vue/libs/vue-select.scss';

  input[type="file"] {
    display: none;
  }

  .custom-file-upload:hover{
    cursor: pointer;
  }

  .card-guia-corte{
    padding: 0px !important;
  }

  .card{
    box-shadow: none;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-bottom: 0px
  }

  .categoria-radios{
    margin-top: -20px;
    margin-bottom: 10px;
  }

  .letraSelect{
    border: 2px solid black;
  }

</style>